import React from 'react';
import './BlogCalloutBox.css';

const BlogCalloutBox = ({ type = 'info', children, title }) => {
  return (
    <div className={`blog-callout ${type}`}>
      {title && <h4 className="callout-title">{title}</h4>}
      <div className="callout-content">
        {children}
      </div>
    </div>
  );
};

export default BlogCalloutBox;
